import { buildConfig } from '@build/gb/sidedoor/build/build-config';
import { Environment } from '@config';

export const environment: Environment = {
  ...buildConfig,
  name: 'dev',
  production: false,
  runtimeConfigPath: 'config.json',
  posthog: {
    key: 'phc_TumPoffTGXAgd1sVnapHThFQvd4ixgXV60r3Dx8lv8e',
    host: 'https://eu.i.posthog.com',
  },
};
